import { useEffect, useState } from 'react';
import './App.css';

function App() {

  const privateSale = {initUnlock: (30233304+17766696), startVesting: new Date("2024-01-15"), stopVesting: new Date("2026-01-15"), totalTokens: (100777680+59222320)};
  const publicSaleRepublic = {initUnlock: 7500000, startVesting: new Date("2024-03-08"), stopVesting: new Date("2024-09-08"), totalTokens: 25000000};
  const publicSaleDaoMaker = {initUnlock: 1500000, startVesting: new Date("2024-04-15"), stopVesting: new Date("2024-10-15"), totalTokens: 5000000};
  const massaTeam = {initUnlock: 6000000, startVesting: new Date("2024-01-15"), stopVesting: new Date("2029-01-15"), totalTokens: 120000000};
  const ecoSystem = {initUnlock: 15500000, startVesting: new Date("2024-01-15"), stopVesting: new Date("2029-01-15"), totalTokens: 310000000};
  const testNet = {initUnlock: 24000000, startVesting: new Date("2024-01-15"), stopVesting: new Date("2026-01-15"), totalTokens: 80000000};
  const decentralizationProgram = {initUnlock: 0, startVesting: new Date("2026-01-15"), stopVesting: new Date("2029-01-15"), totalTokens: 300000000};
  const today = new Date();
  const [massaPrice, setMassaPrice] = useState<number>();
  const [MassaInfo, setMassaInfo] = useState<any>();
  const [rewards, setRewards] = useState<number>();
  const [showDetails, setShowDetails] = useState(false);
  const parts = [privateSale, publicSaleRepublic, publicSaleDaoMaker, massaTeam, ecoSystem, testNet, decentralizationProgram];

  useEffect (() => {
    const cookieName = 'coingecko';
    calculationRewards();
    getMassaInfo();
    if(getCookieValue(cookieName) === 0) {
      getMassaPrice();
    }
    else {
      setMassaPrice(getCookieValue(cookieName));
    };
  }, []);

  const toggleDetails = () => {
    setShowDetails(!showDetails);
  };

  function setCookie(cookieName: string, value: number) {
    const now = Date.now();
    const oneMinuteInMilliseconds = 60000;
    const expirationTime = now + oneMinuteInMilliseconds;
  
    document.cookie = `${cookieName}=${value}; expires=${new Date(expirationTime).toUTCString()}`;
  };

  function getCookieValue(cookieName: string): number {
    const cookieArr = document.cookie.split('; ');
  
    for (let i = 0; i < cookieArr.length; i++) {
      const cookiePair = cookieArr[i].split('=');
  
      if (cookiePair[0] === cookieName) {
        return parseFloat(cookiePair[1]);
      }
    }
    
    return 0;
  };

  async function getMassaPrice() {
    try {
      const coingecko = await fetch("https://api.coingecko.com/api/v3/simple/price?ids=massa&vs_currencies=usd");
      if (!coingecko.ok) {
        throw new Error('Error Coingecko');
      }
      let json = await coingecko.json();
      setMassaPrice(json.massa.usd);
      setCookie("coingecko", json.massa.usd);
    } catch {
      setMassaPrice(undefined);
    }
  }

  async function getMassaInfo() {
    try {
      const massainfo = await fetch("https://explorer-api.massa.net/info");
      if (!massainfo.ok) {
        throw new Error('Error Massa Info');
      }
      let json = await massainfo.json();
      setMassaInfo(json);
    } catch {
      setMassaInfo(undefined);
    }
  }


  function calculationRewards() {
    const startBC = new Date("2024-01-15");
    const timeDifference = today.getTime() - startBC.getTime();
    const dayDifference = (timeDifference / (1000 * 60 * 60 * 24));
    const rewards = 64377504 / 365 * dayDifference;

    setRewards(rewards);
  }

  function calculationUnlocked(part: any): number {
    const timeDifference = today.getTime() - part.startVesting.getTime();
    const dayDifference = (timeDifference / (1000 * 60 * 60 * 24));

    if (today.getTime() > part.stopVesting.getTime()) {
        return part.totalTokens;
    }
    
    if(dayDifference > 0) {
      const totalVesting = part.totalTokens-part.initUnlock;
      const totalVestingDaysDifference = part.stopVesting.getTime()-part.startVesting.getTime();
      const totalVestingDays = totalVestingDaysDifference / (1000 * 60 * 60 * 24);
      const unlockPerDay = totalVesting/totalVestingDays;

      return part.initUnlock + (unlockPerDay*dayDifference);
    }
    return 0;
  }

  function calculationLocked(part: any): number {
    const unlocked = calculationUnlocked(part);
    return part.totalTokens-unlocked;
  }

  function calculationTotal(): any {
    let locked = 0;
    let unlocked = 0;
    let total = 0;

    let unlockedTokens, lockedTokens;
    parts.forEach(part => {
      unlockedTokens = calculationUnlocked(part);
      lockedTokens = part.totalTokens - unlockedTokens;

      unlocked = unlocked + unlockedTokens;
      locked = locked + lockedTokens;
      total = total + unlockedTokens + lockedTokens;
    });

    return {locked: locked, unlocked: unlocked, total: total};
  }

  function cuteNumber(number: number) {
    return parseFloat(number.toFixed(0)).toLocaleString("en", {minimumFractionDigits: 0});
  }

  return (
    <div>
      <div className="header">
        <div className="container display-6">
          MASSA BLOCKCHAIN INFORMATIONS
        </div>
      </div>
      <div className="container pt-2">
        <div className="table-responsive mt-4">
          &bull; Based on Massa Explorer API
          <table className="table table-striped text-center">
            <thead>
              <tr>
                <th scope="col" className="col">UNLOCKED</th>
                <th scope="col" className="col">LOCKED</th>
                <th scope="col" className="col">TOTAL</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{MassaInfo ? cuteNumber(MassaInfo.circulating_supply/MassaInfo.total_supply*100) + "%" : "-"}</td>
                <td>{MassaInfo ? cuteNumber((MassaInfo.total_supply-MassaInfo.circulating_supply)/MassaInfo.total_supply*100) + "%" : "-"}</td>
                <td>100%</td>
              </tr>
              <tr className="fw-bold">
                <td>{MassaInfo ? cuteNumber(MassaInfo.circulating_supply) : "-"}</td>
                <td>{MassaInfo ? cuteNumber(MassaInfo.total_supply-MassaInfo.circulating_supply) : "-"}</td>
                <td>{MassaInfo ? cuteNumber(MassaInfo.total_supply) : "-"}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="row text-center">
        <div className="col pt-2">
          <div className="card">
            <div className="card-header fw-bold">Massa Price</div>
            <div className="card-body">${(massaPrice ? massaPrice : "-")}</div>
          </div>
        </div>
        <div className="col pt-2">
          <div className="card">
            <div className="card-header fw-bold">Market Cap</div>
            <div className="card-body">${(massaPrice && MassaInfo ? cuteNumber(MassaInfo.circulating_supply*massaPrice) : "-")}</div>
          </div>
        </div>
        <div className="col pt-2">
          <div className="card">
            <div className="card-header fw-bold">Fully Diluted Value</div>
            <div className="card-body">${(massaPrice && MassaInfo ? cuteNumber(MassaInfo.total_supply*massaPrice): "-")}</div>
          </div>
        </div>
      </div>
      <div className="table-responsive mt-4">
        &bull; Based on whitepaper <span className="fst-italic">(theoric)</span>
        <table className="table table-striped text-end">
          <thead>
            <tr>
              <th scope="col" className="col text-start"></th>
              <th scope="col" className="col">UNLOCKED</th>
              <th scope="col" className="col">LOCKED</th>
              <th scope="col" className="col">TOTAL</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th className="text-start" scope="row">Private Sale</th>
              <td>{cuteNumber(calculationUnlocked(privateSale))}</td>
              <td>{cuteNumber(calculationLocked(privateSale))}</td>
              <td>{cuteNumber(privateSale.totalTokens)}</td>
            </tr>
            <tr>
              <th className="text-start" scope="row">Public Sale <span className="fst-italic">(republic)</span></th>
              <td>{cuteNumber(calculationUnlocked(publicSaleRepublic))}</td>
              <td>{cuteNumber(calculationLocked(publicSaleRepublic))}</td>
              <td>{cuteNumber(publicSaleRepublic.totalTokens)}</td>
            </tr>
            <tr>
              <th className="text-start" scope="row">Public Sale <span className="fst-italic">(daomaker)</span></th>
              <td>{cuteNumber(calculationUnlocked(publicSaleDaoMaker))}</td>
              <td>{cuteNumber(calculationLocked(publicSaleDaoMaker))}</td>
              <td>{cuteNumber(publicSaleDaoMaker.totalTokens)}</td>
            </tr>
            <tr>
              <th className="text-start" scope="row">Massa Team</th>
              <td>{cuteNumber(calculationUnlocked(massaTeam))}</td>
              <td>{cuteNumber(calculationLocked(massaTeam))}</td>
              <td>{cuteNumber(massaTeam.totalTokens)}</td>
            </tr>
            <tr>
              <th className="text-start" scope="row">Ecosystem</th>
              <td>{cuteNumber(calculationUnlocked(ecoSystem))}</td>
              <td>{cuteNumber(calculationLocked(ecoSystem))}</td>
              <td>{cuteNumber(ecoSystem.totalTokens)}</td>
            </tr>
            <tr>
              <th className="text-start" scope="row">Testnet</th>
              <td>{cuteNumber(calculationUnlocked(testNet))}</td>
              <td>{cuteNumber(calculationLocked(testNet))}</td>
              <td>{cuteNumber(testNet.totalTokens)}</td>
            </tr>
            <tr>
              <th className="text-start" scope="row">Decentralization Program</th>
              <td>{cuteNumber(calculationUnlocked(decentralizationProgram))}</td>
              <td>{cuteNumber(calculationLocked(decentralizationProgram))}</td>
              <td>{cuteNumber(decentralizationProgram.totalTokens)}</td>
            </tr>
            <tr>
              <th className="text-start" scope="row">Rewards</th>
              <td>{rewards ? cuteNumber(rewards) : "-"}</td>
              <td>-</td>
              <td>{rewards ? cuteNumber(rewards) : "-"}</td>
            </tr>
            <tr><td className="total-bar"></td><td className="total-bar"></td><td className="total-bar"></td><td className="total-bar"></td></tr>
            <tr>
              <th className="text-start" scope="row">Total</th>
              <td>{cuteNumber((calculationTotal().unlocked+rewards))}</td>
              <td>{cuteNumber(calculationTotal().locked)}</td>
              <td>{cuteNumber((calculationTotal().total+rewards))}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="row text-center">
        <div className="col pt-2">
          <div className="card">
            <div className="card-header fw-bold">Massa Price</div>
            <div className="card-body">${(massaPrice ? massaPrice : "-")}</div>
          </div>
        </div>
        <div className="col pt-2">
          <div className="card">
            <div className="card-header fw-bold">Market Cap</div>
            <div className="card-body">${(massaPrice ? cuteNumber(((calculationTotal().total+rewards)*massaPrice)*(calculationTotal().unlocked+rewards)/(calculationTotal().total+rewards)) : "-")}</div>
          </div>
        </div>
        <div className="col pt-2">
          <div className="card">
            <div className="card-header fw-bold">Fully Diluted Value</div>
            <div className="card-body">${(massaPrice ? cuteNumber((calculationTotal().total+rewards)*massaPrice): "-")}</div>
          </div>
        </div>
      </div>
      <div className="pt-3"><button className="btn btn-sm btn-danger" onClick={toggleDetails}>{showDetails ? "hide" : "show"} details</button></div>
      <div id="details" className={`mt-3 p-2 collapse rounded border border-danger ${showDetails ? 'show' : ''}`}>
        <div>
          <div className="fw-bold">Private Sale</div>
          <div className="ps-3">Initial unlock<br /><span className="badge bg-danger">{cuteNumber(privateSale.initUnlock)} <span className="fst-italic">({cuteNumber(privateSale.initUnlock/privateSale.totalTokens*100)}%)</span></span></div>
          <div className="ps-3">Vesting period<br /><span className="badge bg-danger">{privateSale.startVesting.toDateString()}</span> <span className="badge bg-danger">{privateSale.stopVesting.toDateString()}</span></div>
        </div>
        <div className="pt-1">
          <div className="fw-bold">Public Sale <span className="fst-italic">(republic)</span></div>
          <div className="ps-3">Initial unlock<br /><span className="badge bg-danger">{cuteNumber(publicSaleRepublic.initUnlock)} <span className="fst-italic">({cuteNumber(publicSaleRepublic.initUnlock/publicSaleRepublic.totalTokens*100)}%)</span></span></div>
          <div className="ps-3">Vesting period<br /><span className="badge bg-danger">{publicSaleRepublic.startVesting.toDateString()}</span> <span className="badge bg-danger">{publicSaleRepublic.stopVesting.toDateString()}</span></div>
        </div>
        <div className="pt-1">
          <div className="fw-bold">Public Sale <span className="fst-italic">(daomaker)</span></div>
          <div className="ps-3">Initial unlock<br /><span className="badge bg-danger">{cuteNumber(publicSaleDaoMaker.initUnlock)} <span className="fst-italic">({cuteNumber(publicSaleDaoMaker.initUnlock/publicSaleDaoMaker.totalTokens*100)}%)</span></span></div>
          <div className="ps-3">Vesting period<br /><span className="badge bg-danger">{publicSaleDaoMaker.startVesting.toDateString()}</span> <span className="badge bg-danger">{publicSaleDaoMaker.stopVesting.toDateString()}</span></div>
        </div>
        <div className="pt-1">
          <div className="fw-bold">Massa Team</div>
          <div className="ps-3">Initial unlock<br /><span className="badge bg-danger">{cuteNumber(massaTeam.initUnlock)} <span className="fst-italic">({cuteNumber(massaTeam.initUnlock/massaTeam.totalTokens*100)}%)</span></span></div>
          <div className="ps-3">Vesting period<br /><span className="badge bg-danger">{massaTeam.startVesting.toDateString()}</span> <span className="badge bg-danger">{massaTeam.stopVesting.toDateString()}</span></div>
        </div>
        <div className="pt-1">
          <div className="fw-bold">Ecosystem</div>
          <div className="ps-3">Initial unlock<br /><span className="badge bg-danger">{cuteNumber(ecoSystem.initUnlock)} <span className="fst-italic">({cuteNumber(ecoSystem.initUnlock/ecoSystem.totalTokens*100)}%)</span></span></div>
          <div className="ps-3">Vesting period<br /><span className="badge bg-danger">{ecoSystem.startVesting.toDateString()}</span> <span className="badge bg-danger">{ecoSystem.stopVesting.toDateString()}</span></div>
        </div>
        <div className="pt-1">
          <div className="fw-bold">Testnet</div>
          <div className="ps-3">Initial unlock<br /><span className="badge bg-danger">{cuteNumber(testNet.initUnlock)} <span className="fst-italic">({cuteNumber(testNet.initUnlock/testNet.totalTokens*100)}%)</span></span></div>
          <div className="ps-3">Vesting period<br /><span className="badge bg-danger">{testNet.startVesting.toDateString()}</span> <span className="badge bg-danger">{testNet.stopVesting.toDateString()}</span></div>
        </div>
        <div className="pt-1">
          <div className="fw-bold">Decentralization Program</div>
          <div className="ps-3">Initial unlock<br /><span className="badge bg-danger">{cuteNumber(decentralizationProgram.initUnlock)} <span className="fst-italic">({cuteNumber(decentralizationProgram.initUnlock/decentralizationProgram.totalTokens*100)}%)</span></span></div>
          <div className="ps-3">Vesting period<br /><span className="badge bg-danger">{decentralizationProgram.startVesting.toDateString()}</span> <span className="badge bg-danger">{decentralizationProgram.stopVesting.toDateString()}</span></div>
        </div>
      </div>
      <div className="footer pt-3 text-muted small text-center">
        <div>Donate</div>
        <div><code>AU1L3YbT7SBwxdVwzacoonEgou5oXi5mNfXMaXqYhoL69GVrDUrE</code></div>
      </div>
      </div>
    </div>
  );
}

export default App;
